(function () {
  'use strict';

  // Component used for booking item and booking item service item

  angular
    .module('app')
    .component('declineBookingItemNotification', declineBookingItemNotification());

  function declineBookingItemNotification() {
    return {
      bindings: {
        notification: '<',
        bookingItem: '<',
        bookingItemServiceItem: '<',
        companyId: '<',
        option: '<', // decline / cancel
        onBookingItemNotificationDeclined: '&',
      },
      controller: DeclineBookingItemNotificationComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-notification/decline-notification/' +
        'decline-booking-item-notification.component.html',
    };
  }

  DeclineBookingItemNotificationComponent.$inject = [
    'UtilService',
    'BookingItemNotificationService',
  ];

  function DeclineBookingItemNotificationComponent(UtilService, BookingItemNotificationService) {
    let vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.declineBookingNotification = declineBookingNotification;

    vm.$onInit = function () {
      // New notification
      if (!vm.notification) {
        vm.notification = {};
      }

      vm.notification.confirmed_by = '';
      vm.notification.observations = '';
    };

    function declineBookingNotification(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      vm.notification.status = vm.option === 'decline' ? 'declined' : 'cancelled';

      let params = {
        company_id: vm.companyId,
      };

      let bookingItemServiceItemId = vm.bookingItemServiceItem
        ? vm.bookingItemServiceItem.id
        : null;

      vm.sendingForm = true;
      BookingItemNotificationService.saveBookingItemNotification(
        vm.bookingItem.booking_id,
        vm.bookingItem.id,
        bookingItemServiceItemId,
        vm.notification,
        params,
        {}
      ).then(function (response) {
        response = response.data;

        if (!response.errors) {
          let data = {
            notification: response.notification,
            booking_item_status: response.booking_item_status,
            booking_status: response.booking_status,
            booking_item_service_item_status: null,
          };

          if (vm.bookingItemServiceItem) {
            data.booking_item_service_item_status = response.booking_item_service_item_status;
          }

          vm.onBookingItemNotificationDeclined({ dataObj: data });

          vm.sendingForm = false;
        }
      });
    }
  }
})();
